<template>
  <div id="app">
    <div v-if="is_loading">
      <div class="loading-screen">
        <div class="loading-logo-text">
          <div class="logo-azienda">
            <img src="https://repalnet.plesk.lithos.it/wp-content/uploads/2020/06/logo-repalnet-bianco.png" alt="">
          </div>
          <div class="testo">
            Caricamento piattaforma...

          </div>
        </div>
      </div>
    </div>
    <template v-else class="contenuto-pagina">
      <xmenu/>
      <div class="page-container">
        <router-view/>
      </div>
      <Footer style="padding-top:40px;"/>
    </template>

    <b-modal v-model="show_login" hide-footer hide-header size="lg">
      <xlogin v-if="show_login" @close="show_login = false"/>
    </b-modal>
    <b-modal v-model="show_signup" hide-footer hide-header size="lg">
      <xsignup v-if="show_signup" @close="show_signup = false"/>
    </b-modal>

  </div>
</template>
<script type="text/javascript">
import Vue from 'vue'
import xmenu from './components/menu.vue'
import xlogin from './components/login.vue'
import xsignup from './components/signup.vue'
import Footer from '@/components/footer'
export default {
  components: {
    xmenu,
    xlogin,
    xsignup,
    Footer,
  },
  data () {
    return {
      show_login: false,
      show_signup: false,
      user: null,
      token: localStorage.token,
      order_statuses: [
        'created',
        'assigned',
        'pending',
        'accepted',
        'delivering',
        'delivered',
        'canceled',
      ],
    }
  },
  computed: {
    is_loading () {
      // return true
      return this.token && !this.user
    },
  },

  created () {
    Vue.prototype.$store = this

    this.$http.interceptors.request.use(config => {
      if (this.token) {
        config.headers.common.Authorization = 'bearer '+this.token
      }
      return config
    }, error => {
      return Promise.reject(error)
    })

    this.$http.interceptors.response.use(res => {
      return res
    }, err => {
      let res = err.response
      if (res) {
        console.log(res)
        switch (res.status) {
          case 400:
            alert((res.data.message || 'Dati non validi'))
            break
          case 422:
            alert('Dati non validi:\n'+Object.values(res.data.errors).join('\n'))
            break
          case 500:
            alert('Errore di sistema')
            break
        }
      }
      return Promise.reject(err)
    });

    this.refreshUser()

  },

  methods: {
    linkTo (file) {
      return '//'+location.hostname+'/storage/'+file
    },
    refreshUser () {
      if (!this.token) {
        this.user = null
      } else {
        this.$http.get('self')
        .then(res => {
          this.user = res.data
        }, err => {
          console.log(err.response)
          if (err.response && err.response.status == 401) {
            this.user = null
            this.token = null
          } else {
            setTimeout(() => this.refreshUser(), 2000)
          }
        })
      }
    },
  },

  watch: {
    token (token) {
      if (!token) {
        localStorage.removeItem('token')
      } else {
        localStorage.token = token
      }
    },
    show_signup(v) {
      if (v) this.show_login = false
    },
    show_login(v) {
      if (v) this.show_signup = false
    },
  },
}
</script>
<style >
.loading-screen{
  height: 100vh;
  width: 100%;
  background-color:#465053;
  display: flex;
  justify-content: center;
  align-items: center;
}
.loading-screen .testo{
  color:white;
  font-size:22px;
}
.loading-screen .loading-logo-text{
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction:column;
}
.loading-screen .loading-logo-text img{
  max-width:400px;
}
.loading-screen .loading-logo-text .testo{
  padding-top:50px;
}
/* html, body{
  overflow-y: hidden !important;
} */
#app{
  height: 100%;
  /* display: flex;
  flex-direction: column;
  justify-content: space-between; */
  overflow: hidden;
}
.page-container{
  min-height:300px;
}


</style>
